import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const columnCardDefaultVariants = {}
const columnCardCompoundVariants = []

const columnCardSlotNames = [
  [
    "root",
    "column-card__root"
  ],
  [
    "image",
    "column-card__image"
  ],
  [
    "contentWrapper",
    "column-card__contentWrapper"
  ],
  [
    "title",
    "column-card__title"
  ],
  [
    "description",
    "column-card__description"
  ],
  [
    "imageWrapper",
    "column-card__imageWrapper"
  ],
  [
    "image",
    "column-card__image"
  ],
  [
    "ctaText",
    "column-card__ctaText"
  ]
]
const columnCardSlotFns = /* @__PURE__ */ columnCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, columnCardDefaultVariants, getSlotCompoundVariant(columnCardCompoundVariants, slotName))])

const columnCardFn = memo((props = {}) => {
  return Object.fromEntries(columnCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const columnCardVariantKeys = []
const getVariantProps = (variants) => ({ ...columnCardDefaultVariants, ...compact(variants) })

export const columnCard = /* @__PURE__ */ Object.assign(columnCardFn, {
  __recipe__: false,
  __name__: 'columnCard',
  raw: (props) => props,
  variantKeys: columnCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, columnCardVariantKeys)
  },
  getVariantProps
})